import copyCustomColorsCSSRulesForBlocks from './copy-custom-colors-css-rules-for-blocks.js';
import removeCustomColorsCSSRulesForBlocks from './remove-custom-colors-css-rules-for-blocks';
import cleanUpCustomColorsFromActivePage from './clean-up-custom-colors-from-active-page.js';

export default {
  copyCustomColorsCSSRulesForBlocks,
  removeCustomColorsCSSRulesForBlocks,
  cleanUpCustomColorsFromActivePage,
};
